import React from 'react';
import { Box, Button, Typography } from '@mui/joy';
import { EXPIRY_SHORTCUTS, calcExpiryFromBaseDate } from './formCommon';

const shortcutButtonSx = {
  borderColor: 'primary.500',
  color: 'primary.500',
  '&:hover': { backgroundColor: 'primary.50' },
  '&.Mui-disabled': { opacity: 0.45 }
};

const ExpiryDateShortcuts = ({
  baseDate,
  onExpiryChange,
  hintLabel,
  shortcuts = EXPIRY_SHORTCUTS
}) => {
  const disabled = !baseDate;

  const handleShortcut = ({ months = 0, years = 0 }) => {
    const expiry = calcExpiryFromBaseDate(baseDate, { months, years });
    if (expiry) onExpiryChange(expiry);
  };

  return (
    <Box sx={{ mb: 2 }}>
      {hintLabel && (
        <Typography level="body-xs" sx={{ mb: 0.75, color: 'text.secondary' }}>
          {hintLabel}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {shortcuts.map((shortcut) => (
          <Button
            key={shortcut.label}
            type="button"
            size="sm"
            variant="outlined"
            disabled={disabled}
            onClick={() => handleShortcut(shortcut)}
            sx={shortcutButtonSx}
          >
            {shortcut.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default ExpiryDateShortcuts;
